const wnumb = require('wnumb');
const noUiSlider = require('nouislider');

export default class BackupCalculator {
    constructor(callback) {
        this.calculateStorage();
        this.clickableMarkers();

        if (callback) {
            callback();
        }
    }

    clickableMarkers() {
        $('.noUi-value-large').click(function () {
            $(this).parents('.noUi-target').get(0).noUiSlider.set(
                Math.round($(this).data('value'))
            );
        });
    }

    calculateStorage(){
        const slider = $('#slider-storage').get(0);
        const value = $('#value-storage').find('span');
        const values = [10, 50, 100, 250, 500, 800, 1000, 2000, 5000, 10000];

        noUiSlider.create(slider, {
            step: 10,
            range: this.makeRange(values),
            start: 10,
            tooltips: [wnumb({decimals: 0})],
            connect: 'lower',
            pips: {
                mode: 'values',
                values: values,
            }
        })

        this.updateValueEvent(slider, value, 2.5);
    }

    makeRange(values) {
        let res = {
            "min": [Math.min(...values), values[1] - values[0]],
            "max": [Math.max(...values)],
        }

        let step = Math.round(100 / (values.length - 1) * 100) / 100;

        for (let i = 1; i < values.length - 1; i++) {
            res[step * i + '%'] = [values[i], values[i + 1] - values[i]];
        }

        return res;
    }

    updateValueEvent(slider, value, priceOfStep, offset = 0) {
        slider.noUiSlider.on('update', function (values) {
            $(value).html(parseInt(values[0]));
            $(value).data('price', parseInt((values[0] - offset) * priceOfStep));
            this.calculateTotal()
        }.bind(this));
    }

    calculateTotal() {
        let storagePrice = $('#value-storage').find('span').data('price');

        $('#price-storage').html(
            wnumb({thousand: '&nbsp;', decimals: 2}).to(storagePrice)
        );
    }
}
